import { Reveal, ChapterHead, CHAKRAS } from "./shared";

export default function WhatIs() {
  const ordered = [...CHAKRAS].reverse();
  return (
    <section id="chakra-tree" className="py-20 lg:py-32 bg-[#F4F0E6]/50" data-testid="what-is-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-14 lg:gap-20 items-center">
        <div className="lg:col-span-7">
          <ChapterHead
            number="02"
            label="The Chakra Tree"
            title="The Story of the Tree"
            testid="what-is"
          />
          <Reveal delay={0.15}>
            <p className="mt-8 text-base sm:text-lg text-[#1A201C]/70 leading-relaxed max-w-xl" data-testid="what-is-text">
              The 7 Chakra Crystal Tree brings together a natural-inspired tree form,
              hand-arranged crystal stones and seven chakra-inspired colours — from
              white at the crown to red at the root, every one of the seven stones is
              clearly represented. The result is a piece of decorative craftsmanship
              with a quiet, meaningful presence in everyday spaces.
            </p>
            <p className="mt-6 text-sm text-[#1A201C]/55 leading-relaxed max-w-xl border-l-2 border-[#C6A15B] pl-5" data-testid="what-is-note">
              One of the seven stones is white. Chakra meanings are shared as traditional
              symbolism — a matter of personal reflection, never a medical claim.
            </p>
            <p className="font-hand text-2xl text-[#8C7A56]/80 mt-10" data-testid="what-is-signature">
              seven colours, one tree
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.2} className="lg:col-span-5">
          <div
            className="border border-[#1B1915]/12 bg-[#FDFBF7] rounded-sm p-8 sm:p-10"
            data-testid="chakra-diagram"
          >
            <p className="text-[11px] tracking-[0.28em] uppercase text-[#8C7A56]/70 mb-8 text-center">
              Crown to Root — The Seven Colours
            </p>
            <div className="flex flex-col">
              {ordered.map((c, i) => (
                <div key={c.key} className="flex items-center gap-5 group" data-testid={`chakra-diagram-row-${c.key}`}>
                  <div className="flex flex-col items-center">
                    <span
                      className={`w-3.5 h-3.5 rounded-full ring-4 ring-transparent group-hover:ring-[#1B1915]/5 transition-[box-shadow] duration-300 ${c.light ? "border border-[#1B1915]/25" : ""}`}
                      style={{ backgroundColor: c.hex }}
                    />
                    {i < ordered.length - 1 && <span className="w-px h-7 bg-[#1B1915]/15" />}
                  </div>
                  <div className="flex items-baseline justify-between flex-1 py-1">
                    <span className="font-serif-display text-lg text-[#1B1915]">{c.name}</span>
                    <span className="text-[11px] tracking-[0.2em] uppercase text-[#1A201C]/50">
                      {c.colour}
                    </span>
                  </div>
                </div>
              ))}
              <div className="mt-6 pt-6 border-t border-[#1B1915]/12" data-testid="chakra-diagram-note">
                <p className="text-xs text-[#1A201C]/55 leading-relaxed">
                  Seven natural stone colours — white, purple, blue, green, yellow, orange and
                  red — arranged through the canopy, each traditionally linked to one chakra.
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
